import { FileInputRenderer } from '@exam-center/components';
import {
  Divider,
  Flex,
  Grid,
  type OptionSelectionProps,
  SectionTitle,
  Text,
} from '@shared/components';

import { BLOCKED_ITEM_FORM_CONDITIONS } from '../../constants';
import {
  BlockedInformationCreationFields,
  type BlockedInformationCreationFieldsProps,
} from '../blocked-information-creation-fields';
import { EmployeeInformationFields } from '../employee-information-fields';
import { ExamSessionInformationFields } from '../exam-session-information-fields';

import { type BaseFieldsProps } from './types';

export type CheaterBlockedRecordInfoFormFieldProps = BlockedInformationCreationFieldsProps & {
  fields: {
    blockedType: BaseFieldsProps & { options: OptionSelectionProps[] };
    examDate: BaseFieldsProps;
    examRound: BaseFieldsProps;
    examStartTime: BaseFieldsProps;
    examEndTime: BaseFieldsProps;
    fileDocuments: BaseFieldsProps;
  };
};

export default function CheaterBlockedRecordInfoFormField(
  props: Readonly<CheaterBlockedRecordInfoFormFieldProps>,
) {
  const { fields, visibleFields, slots } = props;

  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        gap: theme.spacing(6),
        p: theme.spacing(6),
      })}
    >
      <SectionTitle title='Person Information' />
      <EmployeeInformationFields
        fields={{
          blockedType: {
            mode: 'input',
            name: fields.blockedType.name,
            slotProps: {
              options: fields.blockedType.options,
              required: fields.blockedType.required,
            },
          },
        }}
      />
      <Divider />
      <SectionTitle title='Blocklist Information' />
      <BlockedInformationCreationFields
        fields={{
          blockedAt: fields.blockedAt,
          blockedCourse: fields.blockedCourse,
          enforcementEnd: fields.enforcementEnd,
          reason: fields.reason,
          examCenter: fields.examCenter,
        }}
        visibleFields={visibleFields}
        options={{
          blockedUntilMode: 'date',
        }}
        slots={{ ...slots, blockedAtLabel: 'วันที่เริ่มระงับสิทธิ์' }}
      />

      <Divider />
      <SectionTitle title='Exam Sessions' />
      <ExamSessionInformationFields
        fields={{
          examDate: {
            mode: 'input',
            name: fields.examDate.name,
            slotProps: {
              required: true,
            },
          },
          examRound: {
            mode: 'input',
            name: fields.examRound.name,
            slotProps: {
              required: true,
            },
          },
          examStartTime: {
            mode: 'input',
            name: fields.examStartTime.name,
            slotProps: {
              required: true,
            },
          },
          examEndTime: {
            mode: 'input',
            name: fields.examEndTime.name,
            slotProps: {
              required: true,
            },
          },
        }}
      />

      <Divider />
      <SectionTitle title='File Documents' />
      <Grid
        sx={{
          gridTemplateColumns: '240px minmax(auto, 600px)',
          gap: (theme) => theme.spacing(6),
        }}
      >
        <Text variant='body1Semibold'>เอกสารสำคัญ</Text>
        <FileInputRenderer
          mode='input'
          name={fields.fileDocuments.name}
          slotProps={{
            label: 'เอกสารหลักฐานที่เกี่ยวข้อง',
            placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
            accept: BLOCKED_ITEM_FORM_CONDITIONS.ALLOW_FILE_EXTENSIONS,
            maxFiles: BLOCKED_ITEM_FORM_CONDITIONS.MAX_FILE_ATTACHMENTS,
            multiple: true,
          }}
        />
      </Grid>
    </Flex>
  );
}
